import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { InputWrap, InputField, InputCheckbox } from "components";
import { observer, inject } from 'mobx-react';
import {
    ACCESSOR_SEARCH_BOX, DATE_FORMAT, DATE_PLACHOLDER_FORMAT, DATE_SEPARATE, CONFIG_FILE_EDITION,
    PREBUILT_GROUP_CODE, PREBUILT_MODEL_CODE, AI_SETTING_NONE
} from '../../core/utils/constants';
import DateComponent from '../../components/DateComponent'
import "./style.scss";
import moment from 'moment'
@inject('commonStore', 'documentsStore', 'modalStore')
@observer
class SearchBox extends Component {
    tableOriginalSize = 0;
    constructor(props) {
        super(props);
        const { savedData } = this.props;
        this.state = {
            filterData: {},
            errors: {
                fromTime: "",
                toTime: "",
                hasError: () => {
                    return (this.state?.errors?.fromTime !== "" || this.state?.errors?.toTime !== "")
                }
            },
            isCollapseOut: (savedData?.isCollapseOut === true) ? savedData?.isCollapseOut : false,
        };
    }
    /**
     * handleFilterDataChange
     * handle all filter data change
     * update current state
     * 
     * @param {string} name name of the field
     * @param {string} value value of the field
     * 
     * @returns Null setState and rerender component
     */
    handleFilterDataChange = (name, value) => {
        const { documentsStore } = this.props;
        if ([ACCESSOR_SEARCH_BOX.TO_TIME, ACCESSOR_SEARCH_BOX.FROM_TIME].includes(name)) {
            if (value) {
                let timeStamp = moment(value).format(DATE_FORMAT.time_stamp)
                this.validationDateData(name, timeStamp)
            }
        }
        if ([ACCESSOR_SEARCH_BOX.FORM_GROUP].includes(name)) {
            // 帳票グループ指定
            let data = {}
            if (value.includes(',')) {
                // AI設定の場合はグループと定義両方指定
                let formGroupId = value.split(',')[0];
                let configFileCode = value.split(',')[1];

                documentsStore.filterAIDefinitationsByGroup();
                data[ACCESSOR_SEARCH_BOX.FORM_GROUP] = formGroupId;
                data[ACCESSOR_SEARCH_BOX.FILE_CODE_CONFIG] = configFileCode;
                documentsStore.updateTempSearchBoxFiler(data);
                return;
            }
            documentsStore.getDefinitationsByGroup(value);
            documentsStore.resetConfigFileCode();
            data[name] = value;
            documentsStore.updateTempSearchBoxFiler(data);
            return;
        }
        if ([ACCESSOR_SEARCH_BOX.FILE_CODE_CONFIG].includes(name)) {
            // 帳票定義 (またはAI設定) 選択時
            let data = {}
            if (value.includes("ai-setting,")) {
                // AI設定が選択された場合の分岐
                data[ACCESSOR_SEARCH_BOX.AI_SETTING_NAME] = value.replace("ai-setting,", "");
                if (documentsStore.tempFilterData?.formGroupId != PREBUILT_GROUP_CODE.AI) {
                    // 帳票グループフィルタがAI出ない場合は帳票定義をクリア
                    data[ACCESSOR_SEARCH_BOX.FILE_CODE_CONFIG] = null;
                }
            } else {
                // 通常の帳票定義
                data[name] = value;
                data[ACCESSOR_SEARCH_BOX.AI_SETTING_NAME] = null;
            }
            documentsStore.updateTempSearchBoxFiler(data);
            return;
        }
        let data = {}
        data[name] = value;
        documentsStore.updateTempSearchBoxFiler(data);
    }

    /**
     * componentWillMount
     * get definitions of user
     * 
     */
    componentWillMount() {
        this.props.documentsStore.getDefinitationsInTeam();
        this.props.documentsStore.getAllDefinitationsGroupInTeam();
        this.props.documentsStore.getAiSettings();
        this.props.commonStore.teamStore.getTeamOfUser();
    }

    componentDidMount() {
        const { isCollapseOut } = this.state;
        document.getElementById("collapsible").checked = isCollapseOut;
        this.documentHandleCollapse(!isCollapseOut);
        let tableContainerHeight = document.getElementsByClassName("table-container");
        if (tableContainerHeight && tableContainerHeight[0]) {
            this.tableOriginalSize = tableContainerHeight[0].offsetHeight;
        }

        this.tableHandler();
    }

    /**
     * validationDateData
     * 
     * rules:
     * fromTime is required when toTime has value
     * toTime is required when fromTime has value
     * fromTime is smaller than fromTime
     * 
     * @param {string} currentField name of the field
     * @param {string} newValue value of the field
     * 
     * @returns set errors setState and rerender component
     */
    validationDateData = (currentField, newValue) => {
        let filterData = this.state.filterData
        let errors = this.state.errors;

        errors.fromTime = "";
        errors.toTime = "";
        if (newValue) {
            if (currentField === ACCESSOR_SEARCH_BOX.FROM_TIME && filterData.toTime && newValue > filterData.toTime) {
                errors.fromTime = 'search_box.from_time_greater_to_time';
            }
            if (currentField === ACCESSOR_SEARCH_BOX.TO_TIME && filterData.fromTime && filterData.fromTime > newValue) {
                errors.toTime = 'search_box.from_time_greater_to_time';
            }
        }
        this.setState({ errors: { ...this.state.errors, ...errors } })
    }

    documentHandleCollapse(isCollapseOut) {
        let element = document.getElementById("collapse-header");
        if (isCollapseOut && element) {
            element.classList.add("collapse_in");
            element.classList.remove("collapse_out");
        } else {
            element.classList.remove("collapse_in");
            element.classList.add("collapse_out");
        }
    }

    collapseHander = (e) => {
        const { isCollapseOut } = this.state;
        const { documentsStore } = this.props;

        documentsStore.updateSearchBoxCollapse(!isCollapseOut);
        this.documentHandleCollapse(isCollapseOut);
        document.getElementById("collapsible").checked = !isCollapseOut
        this.setState({ isCollapseOut: !isCollapseOut });
        this.tableHandler();
    }

    tableHandler = () => {
        // compute table.
        // search box height
        let collapsibleContentHeight = document.getElementsByClassName("collapsible-content");
        if (collapsibleContentHeight && collapsibleContentHeight[0]) {
            let tableContainerHeight = document.getElementsByClassName("table-container");
            if (tableContainerHeight && tableContainerHeight[0]) {
                let tableHeight = tableContainerHeight[0].offsetHeight;
                if (collapsibleContentHeight[0].offsetHeight === 0) {
                    tableContainerHeight[0].style.height = this.tableOriginalSize - 2 + "px";
                } else {
                    tableContainerHeight[0].style.height = tableHeight - collapsibleContentHeight[0].offsetHeight + 10.7 + "px";
                }

                // compute for table body
                let table = document.getElementsByTagName("table");
                if (table && table[0]) {
                    let tableHead = document.getElementsByTagName("thead");
                    if (tableHead && tableHead[0]) {
                        let tableBody = document.getElementsByTagName("tbody");
                        if (tableBody && tableBody[0]) {
                            let tableBodyHeight = table[0].offsetHeight - tableHead[0].offsetHeight;
                            tableBody[0].style.height = tableBodyHeight + "px";
                        }
                    }
                }
            }
        }
    }

    getFormGroupValue = () => {
        const { documentsStore: { tempFilterData } } = this.props;
        if (tempFilterData?.formGroupId == PREBUILT_GROUP_CODE.AI) {
            return `${tempFilterData?.formGroupId},${tempFilterData?.configFileCode}`;
        } else {
            return tempFilterData?.formGroupId ? tempFilterData?.formGroupId : "";
        }
    }

    getConfigFileValue = () => {
        const { documentsStore: { tempFilterData } } = this.props;
        if (tempFilterData?.aiSettingName) {
            return `ai-setting,${tempFilterData?.aiSettingName}`;
        } else {
            return tempFilterData?.configFileCode ? tempFilterData?.configFileCode : "";
        }
    }

    /**
     * render
     * render search box
     * 
     */
    render() {
        const { t, commonStore: { teamStore } } = this.props;
        return (
            <div className="search-form">
                <div id="collapse-header" className="collapse-header" onClick={() => this.collapseHander()}>
                    <h4 className="sb-form-title">{t("search_box.narrowing_conditions")}</h4>
                </div>
                <input id="collapsible" className="toggle" type="checkbox"></input>

                <div className="collapsible-content row document-search-pannel">
                    <div className="row row-1st" style={{ display: "flex" }}>
                        <div style={{ display: "flex", lineHeight: "30px" }}>
                            <label>{t("search_box.file_name")}</label>
                            <InputField
                                type="text"
                                name={ACCESSOR_SEARCH_BOX.FILE_NAME_INPUT}
                                placeholder={t("search_box.file_name_place_holder")}
                                onChange={this.handleFilterDataChange}
                                value={this.props.documentsStore.tempFilterData?.inputFileName}
                            />
                        </div>

                        <div className="l20">
                            <label>{t("search_box.formGroup")}</label>
                            <select className="select download-select"
                                onChange={(e) => this.handleFilterDataChange(ACCESSOR_SEARCH_BOX.FORM_GROUP, e?.target?.value)}
                                value={this.getFormGroupValue()}
                            >
                                <option key={"null"} value={"null"}>{t("search_box.all_definition_file")}</option>
                                {
                                    this.props?.documentsStore?.listGroupDefinitions.filter((item) => {
                                        return item?.id != PREBUILT_GROUP_CODE.AI
                                    }).map((item) => {
                                        if (item?.id == PREBUILT_GROUP_CODE.PREBUILT) {
                                            return <option key={item?.id} value={item?.id}>{t("download.prebuilt")}</option>
                                        }
                                        return <option key={item?.id} value={item?.id}>{item?.groupName}</option>
                                    })
                                }
                                {
                                    this.props?.documentsStore?.listAllDefinitionsCache.filter((item) => {
                                        return item?.formGroupId == PREBUILT_GROUP_CODE.AI
                                    }).map((item) => {
                                        let id = `${PREBUILT_GROUP_CODE.AI},${item?.id}`;
                                        switch (item?.id) {
                                            case PREBUILT_MODEL_CODE.CLAUDE_3_5:
                                                return <option key={id} value={id}>{t("download.prebuilt_claude_3_5")}</option>
                                            case PREBUILT_MODEL_CODE.CLAUDE_3_7:
                                                return <option key={id} value={id}>{t("download.prebuilt_claude_3_7")}</option>
                                            case PREBUILT_MODEL_CODE.CLAUDE_4_5:
                                                return <option key={id} value={id}>{t("download.prebuilt_claude_4_5")}</option>
                                            case PREBUILT_MODEL_CODE.CLAUDE_4_6:
                                                return <option key={id} value={id}>{t("download.prebuilt_claude_4_6")}</option>
                                            case PREBUILT_MODEL_CODE.CLAUDE_5:
                                                return <option key={id} value={id}>{t("download.prebuilt_claude_5")}</option>
                                            case PREBUILT_MODEL_CODE.GEMINI_3_1_PRO:
                                                return <option key={id} value={id}>{t("download.prebuilt_gemini_3_1_pro")}</option>
                                            case PREBUILT_MODEL_CODE.GEMINI_3_5_FLASH:
                                                return <option key={id} value={id}>{t("download.prebuilt_gemini_3_5_flash")}</option>
                                            case PREBUILT_MODEL_CODE.GEMINI_3_7_FLASH:
                                                return <option key={id} value={id}>{t("download.prebuilt_gemini_3_7_flash")}</option>
                                            default:
                                                return <option key={id} value={id}>{item?.configName}</option>
                                        }
                                    })
                                }
                            </select>
                        </div>

                        <div className="l20">
                            <label>{t("search_box.definition_file")}</label>
                            <select className="select download-select"
                                onChange={(e) => this.handleFilterDataChange(ACCESSOR_SEARCH_BOX.FILE_CODE_CONFIG, e?.target?.value)}
                                value={this.getConfigFileValue()}
                            >
                                <option key={"null"} value={"null"}>{t("search_box.all_definition_file")}</option>
                                {
                                    this.props?.documentsStore?.listAllDefinitions.filter((item) => {
                                        return item?.formGroupId != PREBUILT_GROUP_CODE.AI
                                    }).map((item) => {
                                        if (item?.edition == CONFIG_FILE_EDITION.PREBUILT) {
                                            switch (item?.id) {
                                                case PREBUILT_MODEL_CODE.INVOICE:
                                                    return <option key={item?.id} value={item?.id}>{t("download.prebuilt_invoice")}</option>
                                                case PREBUILT_MODEL_CODE.RECEIPT:
                                                    return <option key={item?.id} value={item?.id}>{t("download.prebuilt_receipt")}</option>
                                                case PREBUILT_MODEL_CODE.VLM_HOJIN:
                                                    return <option key={item?.id} value={item?.id}>{t("download.prebuilt_vlm_hojin")}</option>
                                                default:
                                                    return <option key={item?.id} value={item?.id}>{item?.configName}</option>
                                            }
                                        }
                                        return <option key={item?.id} value={item?.id}>{item?.configName}</option>
                                    })
                                }
                                {
                                    this.props?.documentsStore?.aiSettings.map((item) => {
                                        let id = `ai-setting,${item}`;
                                        let text = item == AI_SETTING_NONE ? t("download.ai.no_setting") : item;
                                        return <option key={id} value={id}>{text}</option>
                                    })
                                }
                            </select>
                        </div>
                    </div>

                    <div className="row row-2nd">
                        <div style={{ display: "flex" }}>
                            <div style={{ lineHeight: "30px" }}>
                                <label>{t("search_box.registered_date")}</label>
                            </div>
                            <div className={"searchbox-dp " + (this.state.errors[ACCESSOR_SEARCH_BOX.FROM_TIME] !== "" ? "error" : "")}>
                                <InputWrap customClass="registered-date-input-wrap">
                                    <div className="input-group date">
                                        <label className="date-label">
                                            <div className="input-group-addon">
                                                <i className="fa fa-calendar"></i>
                                            </div>
                                            <DateComponent placeholder={DATE_PLACHOLDER_FORMAT} name={ACCESSOR_SEARCH_BOX.FROM_TIME} onChange={this.handleFilterDataChange}
                                                value={this.props.documentsStore?.tempFilterData?.fromTime} maxDate={new Date()} />
                                        </label>
                                    </div>
                                    <span className="color-red">{t(this.state.errors[ACCESSOR_SEARCH_BOX.FROM_TIME])}</span>
                                </InputWrap>
                            </div>
                            {/* <div className="col-sm-1 sb-dp-serate-box" style={{textAlign: "center"}}>
                                <label className="hideLabel">{DATE_SEPARATE}</label>
                                <label className="sb-dp-separate">{DATE_SEPARATE}</label>
                            </div> */}
                            <div className="sb-dp-separate">
                                <label>{DATE_SEPARATE}</label>
                            </div>
                            <div className={"searchbox-dp " + (this.state.errors[ACCESSOR_SEARCH_BOX.TO_TIME] !== "" ? "error" : "")}>
                                <InputWrap>
                                    <label className="hideLabel">{t("search_box.to_date")}</label>
                                    <div className="input-group date ">
                                        <label className="date-label">
                                            <div className="input-group-addon">
                                                <i className="fa fa-calendar"></i>
                                            </div>
                                            <DateComponent placeholder={DATE_PLACHOLDER_FORMAT} name={ACCESSOR_SEARCH_BOX.TO_TIME} onChange={this.handleFilterDataChange}
                                                value={this.props.documentsStore?.tempFilterData?.toTime} maxDate={new Date()} />
                                        </label>
                                    </div>
                                </InputWrap>
                                <span className="color-red">{t(this.state.errors[ACCESSOR_SEARCH_BOX.TO_TIME])}</span>
                            </div>
                        </div>

                        <div className="l10">
                            <label>{t("search_box.team_name")}</label>
                            <select className="select download-select"
                                onChange={(e) => this.handleFilterDataChange(ACCESSOR_SEARCH_BOX.TEAM_ID, e?.target?.value)}
                                value={this.props.documentsStore.tempFilterData?.teamId ? this.props.documentsStore.tempFilterData?.teamId : ""}>
                                <option key={"null"} value={"null"}>{t("search_box.all_definition_file")}</option>
                                {
                                    teamStore.teamsOfUser?.map((team) => {
                                        return <option key={team?.id} value={team?.id}>{team?.name}</option>
                                    })
                                }
                            </select>
                        </div>
                    </div>

                    <div className="row row-3rd">
                        <div>
                            <label className="lbl-status">{t("search_box.status")}</label>
                        </div>
                        <div>
                            <InputCheckbox
                                id={ACCESSOR_SEARCH_BOX.STATUS_PROCESSING}
                                type="checkbox"
                                label={t("search_box.processing")}
                                onChange={(e) => this.handleFilterDataChange(ACCESSOR_SEARCH_BOX.STATUS_PROCESSING, e?.target?.checked)}
                                checked={this.props.documentsStore?.tempFilterData?.processing ? true : false}
                            />
                            <InputCheckbox
                                id={ACCESSOR_SEARCH_BOX.STATUS_ERROR}
                                type="checkbox"
                                label={t("search_box.read_error")}
                                onChange={(e) => this.handleFilterDataChange(ACCESSOR_SEARCH_BOX.STATUS_ERROR, e?.target?.checked)}
                                checked={this.props.documentsStore?.tempFilterData?.error ? true : false}
                            />
                            <InputCheckbox
                                id={ACCESSOR_SEARCH_BOX.STATUS_FINISHED}
                                type="checkbox"
                                label={t("search_box.reading_completed")}
                                onChange={(e) => this.handleFilterDataChange(ACCESSOR_SEARCH_BOX.STATUS_FINISHED, e?.target?.checked)}
                                checked={this.props.documentsStore?.tempFilterData?.finished ? true : false}
                            />
                            <InputCheckbox
                                id={ACCESSOR_SEARCH_BOX.STATUS_UPDATED}
                                type="checkbox"
                                label={t("search_box.updated")}
                                onChange={(e) => this.handleFilterDataChange(ACCESSOR_SEARCH_BOX.STATUS_UPDATED, e?.target?.checked)}
                                checked={this.props.documentsStore?.tempFilterData?.updated ? true : false}
                            />
                            <InputCheckbox
                                id={ACCESSOR_SEARCH_BOX.STATUS_CONFIRMED}
                                type="checkbox"
                                label={t("search_box.confirmed")}
                                onChange={(e) => this.handleFilterDataChange(ACCESSOR_SEARCH_BOX.STATUS_CONFIRMED, e?.target?.checked)}
                                checked={this.props.documentsStore?.tempFilterData?.confirmed ? true : false}
                            />
                            <InputCheckbox
                                id={ACCESSOR_SEARCH_BOX.STATUS_DOWNLOADED}
                                type="checkbox"
                                label={t("search_box.downloaded")}
                                onChange={(e) => this.handleFilterDataChange(ACCESSOR_SEARCH_BOX.STATUS_DOWNLOADED, e?.target?.checked)}
                                checked={this.props.documentsStore?.tempFilterData?.downloaded ? true : false}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(SearchBox);
